import { useState } from "react";
import { useTranslation } from "react-i18next";

interface IShowMoreQuestionCommentsProps {
	total_comments: number;
	onClick: (quantityToShow: number) => void;
}

const COMMENTS_PER_PAGE = 3;

const ShowMoreQuestionComments: React.FC<IShowMoreQuestionCommentsProps> = ({ total_comments, onClick }) => {
	const [pagination, setPagination] = useState(1);
	const { t } = useTranslation("session");
	const handleClickMore = () => {
		const updated = pagination + 1;
		setPagination(updated);
		onClick(updated * COMMENTS_PER_PAGE);
	};

	const handleClickLess = () => {
		setPagination(1);
		onClick(COMMENTS_PER_PAGE);
	};

	if (total_comments <= COMMENTS_PER_PAGE) return null;
	if ((COMMENTS_PER_PAGE * total_comments) <= total_comments) return null;
	return (
		<div className="show-more-question-comments-container">
			{(pagination * COMMENTS_PER_PAGE) >= total_comments ? (
				<button onClick={handleClickLess} className="clear no-style">{t("Show fewer")}</button>
			) : (
				<button onClick={handleClickMore} className="clear no-style">{t("Show more comments")}</button>
			)}
		</div>
	);
};

export default ShowMoreQuestionComments;
